import { Suspense, lazy } from 'react';
import { Navigate } from 'react-router-dom';

import AuthLayout from '@/components/layouts/auth-layout';

const CreatePassword = lazy(() => import('@/pages/auth/create-password'));
const ForgotPassword = lazy(() => import('@/pages/auth/forgot-password'));
const ResetPassword = lazy(() => import('@/pages/auth/reset-password'));
const Signin = lazy(() => import('@/pages/auth/signin'));

const Fallback = (
  <div className='p-6 text-sm text-muted-foreground'>Loading…</div>
);

const AuthRoutes = [
  {
    path: '/signin',
    element: <Navigate to='/auth/signin' replace />,
  },
  {
    path: '/auth',
    element: <AuthLayout />,
    children: [
      {
        path: 'signin',
        element: (
          <Suspense fallback={Fallback}>
            <Signin />
          </Suspense>
        ),
      },
      {
        path: 'set-password/:token',
        element: (
          <Suspense fallback={Fallback}>
            <CreatePassword />
          </Suspense>
        ),
      },
      {
        path: 'forgot-password',
        element: (
          <Suspense fallback={Fallback}>
            <ForgotPassword />
          </Suspense>
        ),
      },
      {
        path: 'reset-password/:token',
        element: (
          <Suspense fallback={Fallback}>
            <ResetPassword />
          </Suspense>
        ),
      },
    ],
  },
];

export default AuthRoutes;
